import React, { useState, useEffect } from "react";
import { Row, Col, Table, Modal, Form, Button } from "react-bootstrap";
import CancelledIcon from "../assets/images/profile/shield.svg";
import DeliveredIcon from "../assets/images/profile/delivered.svg";
import TrackOrderIcon from "../assets/images/profile/map.svg";
import OrderReturnIcon from "../assets/images/profile/order-return.svg";
// import CartImg from '../assets/images/cart/cart-img.png'
import BackImg from "../assets/images/cart/back-icon.svg";
import BackArrow from "../assets/images/mobile-back-arrow.svg";
import InvoiceImg from "../assets/images/profile/invoice.svg";
import MapIcon from "../assets/images/profile/map-color.svg";
import MAilIcon from "../assets/images/profile/mail-fill.svg";
import PhoneIcon from "../assets/images/profile/phone.svg";
import Skeleton from "react-loading-skeleton";
import { Link } from "react-router-dom";

import MasterCard from "../assets/images/profile/master-card.svg";
import Visa from "../assets/images/profile/visa.svg";
import AmericanExpress from "../assets/images/profile/american-express.svg";
import Discover from "../assets/images/profile/discover.svg";

// import TooltipIcon from "../assets/images/cart/tooltip.svg";
// import OverlayTrigger from "react-bootstrap/OverlayTrigger";
// import Tooltip from "react-bootstrap/Tooltip";
// import { Rating } from "react-simple-star-rating";

import ShowMoreOrdersIcon from "../assets/images/show-more-products-icon.svg";
import {
  formatPrice,
  formatDate,
  addressStringCreate,
  formatPhoneNumber,
} from "../helpers/helpers";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchOrderList,
  clearOrderMessages,
} from "../features/order/orderActions";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { Rating } from "react-simple-star-rating";
import { createProductReview } from "../features/product/productActions";

const CartSummary = ({ orderDetail }) => {
  const discountTotal = orderDetail?.order_items.reduce(
    (sum, item) => sum + item.variation_regular_price,
    0,
  );

  return (
    <div className="summary-box order-summary-box">
      <div className="box-header">
        <h3>Order Summary</h3>
      </div>
      <div className="table-responsive">
        <Table>
          <tbody>
            <tr>
              <td>Items Total({orderDetail?.order_items.length})</td>
              <td>
                {orderDetail?.currency + formatPrice(orderDetail?.order_amount)}
              </td>
            </tr>

            {discountTotal > 0 && (
              <tr>
                <td>Discounts</td>
                <th>-{orderDetail?.currency + formatPrice(discountTotal)}</th>
              </tr>
            )}

            {orderDetail?.promocode_obj && (
              <tr>
                <td>PromoCode ({orderDetail?.promocode_obj?.code})</td>
                <th>
                  -
                  {orderDetail?.currency +
                    formatPrice(orderDetail?.discount_amount)}
                </th>
              </tr>
            )}

            {orderDetail?.tax_amount > 0 ? (
              <tr>
                <td>Tax</td>
                <td className="discounts">
                  +
                  {orderDetail?.currency + formatPrice(orderDetail?.tax_amount)}
                </td>
              </tr>
            ) : (
              <tr>
                <td>Tax</td>
                <th className="">NO TAX</th>
              </tr>
            )}

            {orderDetail?.shipping_amount > 0 ? (
              <tr>
                <td>Shipping</td>
                <td className="discounts">
                  +
                  {orderDetail?.currency +
                    formatPrice(orderDetail?.shipping_amount)}
                </td>
              </tr>
            ) : (
              <tr>
                <td>Shipping</td>
                <th className="discounts">FREE</th>
              </tr>
            )}

            <tr>
              <th>Order Total</th>
              <th>
                {orderDetail?.currency + formatPrice(orderDetail?.total_amount)}
              </th>
            </tr>
          </tbody>
        </Table>
      </div>
    </div>
  );
};

function MyOrdersComp({ toggleReturnOrders }) {
  const [orderDetail, setOrderDetail] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [RateProduct, setRateProduct] = useState(false);
  const RateProductClose = () => setRateProduct(false);
  const RateProductShow = () => setRateProduct(true);
  const [rating, setRating] = useState(0);
  const [description, setDescription] = useState("");
  const [selectedRatingItem, setSelectedRatingItem] = useState(null);
  const [errors, setErrors] = useState({});
  const handleToggle = (order) => {
    setOrderDetail(order);
    setIsActive((prevState) => !prevState);
  };

  // State to manage pagination
  const [page, setPage] = useState(1);

  // State to store all fetched orders
  const [allOrders, setAllOrders] = useState([]);

  // visible show more
  const [isVisibleShowMore, setIsVisibleShowMore] = useState(true);

  const dispatch = useDispatch();
  const { loading, errorMessage, orderList } = useSelector(
    (state) => state.order,
  );

  const { successMessage } = useSelector((state) => state.product);
  useEffect(() => {
    setAllOrders([]);
    let data = { page: 1, limit: 3 };
    dispatch(fetchOrderList(data));
  }, [dispatch]);

  useEffect(() => {
    if (orderList?.data) {
      setAllOrders((prev) => [...prev, ...orderList.data]);
      setIsVisibleShowMore(orderList.data.length >= 3);
    } else {
      setIsVisibleShowMore(false);
    }
  }, [orderList]);

  useEffect(() => {
    if (errorMessage) {
      toast.error(errorMessage, {
        autoClose: 5000,
        hideProgressBar: true,
        className: "toast-error",
      });
      dispatch(clearOrderMessages()); // Reset the messages after showing the toast
    }
    if (successMessage) {
      toast.success(successMessage, {
        autoClose: 5000,
        hideProgressBar: true,
        className: "toast-success",
      });
      dispatch(clearOrderMessages()); // Reset the messages after showing the toast
    }
  }, [errorMessage, successMessage, dispatch]);

  const loadMoreOrders = () => {
    const nextPage = page + 1;
    let data = { page: nextPage, limit: 3 };
    dispatch(fetchOrderList(data));
    setPage(nextPage); // Update the page number
  };

  const sumOfqty = (orderItems) => {
    return orderItems.reduce((sum, item) => sum + item.qty, 0);
  };

  const displayOrderStatus = (item) => {
    if (item.status_id === 5) {
      return (
        <Link
          style={{ padding: "10px clamp(14px, 0.24vw, 2px)" }}
          to=""
          className="cutsom-bttn delivered-bttn"
        >
          <img src={DeliveredIcon} alt="" /> Delivered
        </Link>
      );
    } else if (item.status_id === 6) {
      return (
        <Link
          style={{ padding: "10px clamp(14px, 0.24vw, 2px)" }}
          to=""
          className="cutsom-bttn order-return-bttn"
        >
          <img src={OrderReturnIcon} alt="" /> Returned
        </Link>
      );
    } else if (item.status_id === 7) {
      return (
        <Link
          style={{ padding: "10px clamp(14px, 0.24vw, 2px)" }}
          to=""
          className="cutsom-bttn cancelled-bttn"
        >
          <img src={CancelledIcon} alt="" /> Cancelled
        </Link>
      );
    } else {
      // Dynamically add the background color class
      return (
        <Link
          style={{ padding: "10px clamp(14px, 0.24vw, 2px)" }}
          to=""
          className={`cutsom-bttn bg-${item.status_bg_color}`}
        >
          {item.status_title}
        </Link>
      );
    }
  };

  const displayTrackOrderDetails = (item) => {
    if (item.awb_url === "") {
      return null;
    } else {
      return (
        <Link
          to={item.awb_url}
          target="_blank"
          className="cutsom-bttn track-order-bttn"
        >
          <img src={TrackOrderIcon} alt="" /> Track Order
        </Link>
      );
    }
  };

  const storeRefundItemInLocalStorage = (item) => {
    try {
      localStorage.setItem("return_item", JSON.stringify(item));
    } catch (error) {
      console.error("Error storing refund item:", error);
    }
  };

  const handleRating = (rate) => {
    setRating(rate);
  };

  const handleSubmitRating = (e) => {
    e.preventDefault();

    const formErrors = {};

    if (rating === 0) {
      formErrors.rating = "Please provide a rating.";
    }

    setErrors(formErrors);

    if (Object.keys(formErrors).length === 0) {
      let data = {
        product_id: selectedRatingItem.product.id,
        rating: rating,
        description: description,
      };
      dispatch(createProductReview(data));

      setRating(0);
      setDescription("");
      setErrors({});
      RateProductClose();
    }
  };

  return (
    <>
      <div className={`${isActive ? "my-order-info isHide" : "my-order-info"}`}>
        <div className="tab-content-header d-none d-md-flex">
          <h3>My Orders</h3>
        </div>

        {loading && allOrders.length === 0 ? ( // Check if loading is true
          <div className="skeleton-loader">
            {Array(3)
              .fill()
              .map(
                (
                  _,
                  index, // Adjust the number of skeletons as needed
                ) => (
                  <div
                    className="order-info-box"
                    key={`skeleton-my-o-${index}`}
                  >
                    <div className="order-info-box-header">
                      <Skeleton height={20} width="80%" />
                      <Skeleton height={15} width="50%" />
                    </div>
                    <div className="order-info-box-body">
                      {Array(2)
                        .fill()
                        .map(
                          (
                            _,
                            itemIndex, // Skeleton for order items
                          ) => (
                            <div
                              className="order-info-box-item"
                              key={`skeleton-item-${itemIndex}`}
                            >
                              <div className="cart-box">
                                <div className="cart-box-img">
                                  <Skeleton
                                    height={95}
                                    width={95}
                                    style={{ borderRadius: 10 }}
                                  />
                                </div>
                                <div className="qty-wrapper">
                                  <span>
                                    <Skeleton height={15} width="100%" />
                                  </span>
                                  <h2>
                                    <Skeleton height={10} width="90%" />
                                  </h2>
                                  <span>
                                    <Skeleton height={10} width="85%" />
                                  </span>
                                </div>
                              </div>
                              <div className="qty-wrapper">
                                <Skeleton height={15} width="40%" />
                                <Skeleton height={15} width="40%" />
                              </div>
                              <div className="bttn-group">
                                <Skeleton height={30} width="80%" />
                              </div>
                            </div>
                          ),
                        )}
                    </div>
                  </div>
                ),
              )}
          </div>
        ) : allOrders?.length > 0 ? (
          <>
            {allOrders.map((order, index) => (
              <div
                className="order-info-box"
                key={"my-order-" + order.id + index}
              >
                <div
                  className="order-info-box-header"
                  onClick={() => handleToggle(order)}
                >
                  <h4>
                    {order.order_number} <span></span> Qty :{" "}
                    {sumOfqty(order.order_items)}
                  </h4>
                  <div className="d-flex align-items-center date-bttn">
                    <h5>
                      Order Date : <span>{formatDate(order.created_at)}</span>
                    </h5>
                    <Link
                      to=""
                      className="cutsom-bttn track-order-bttn style-1"
                    >
                      <img src={TrackOrderIcon} alt="" /> Track Order
                    </Link>
                  </div>
                </div>

                <div className="order-info-box-body">
                  {order.order_items.map((item, item_index) => (
                    <div
                      className="order-info-box-item"
                      key={"item-" + item.id}
                    >
                      <div className="cart-box">
                        <div className="cart-box-img">
                          <Link to={"/products/" + item?.product.slug}>
                            <img
                            height={95}
                                    width={95}
                                    style={{ borderRadius: 10 }}
                              src={`${process.env.REACT_APP_PHP_BACKEND_MEDIA_URL}${item?.product.image}`}
                              alt=""
                            />
                          </Link>
                        </div>
                        <div className="cart-box-content">
                          <span>{item?.product?.category_title}</span>
                          <h2>
                            <Link to={"/products/" + item?.product.slug}>
                              {item?.product?.title}
                            </Link>
                          </h2>
                          <span className="d-none d-md-inline">
                            <Link to={"/products/" + item?.product.slug}>
                              {item.variation_title}
                            </Link>
                            &nbsp;&nbsp;|&nbsp;&nbsp;
                          </span>
                          <Link
                            to={"/products/" + item?.product.slug}
                            className="price-value"
                          >
                            {order.currency} {formatPrice(item.selling_price)}
                          </Link>
                          {item.status_id === 5 &&
                            new Date() <=
                              new Date(item.return_eligible_last_date) && (
                              <p className="return-text">
                                Return eligible through{" "}
                                {formatDate(item.return_eligible_last_date)}
                              </p>
                            )}
                        </div>
                      </div>
                      <div className="qty-wrapper d-none d-md-block">
                        <p className="mb-0"> Qty : {item.qty}</p>
                        <p className="mb-0">
                          {" "}
                          SubTotal : {order.currency}{" "}
                          {formatPrice(item.total_selling_price)}
                        </p>
                        {item.status_id === 5 && (
                          <button
                            onClick={() => {
                              setSelectedRatingItem(item); // ✅ store the item
                              RateProductShow();
                            }}
                            className="rate-btn"
                            style={{
                              background: "none",
                              border: "none",
                              padding: 0,
                              cursor: "pointer",
                              fontSize: "14px",
                              color: "#f5a623",
                            }}
                          >
                            ⭐ Leave a Rating
                          </button>
                        )}
                      </div>

                      <div className="bttn-group">
                        {displayTrackOrderDetails(item)}
                        {displayOrderStatus(item)}
                        {item.status_id === 5 &&
                          new Date() <=
                            new Date(item.return_eligible_last_date) && (
                            <Link
                              to=""
                              onClick={() => {
                                storeRefundItemInLocalStorage(item); // Pass item if needed
                                toggleReturnOrders();
                              }}
                              className="cutsom-bttn order-return-bttn"
                            >
                              <img src={OrderReturnIcon} alt="" /> Order Return
                            </Link>
                          )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </>
        ) : (
          <p className={loading ? "d-none" : ""}>
            No orders found in the account.
          </p>
        )}

        <div className="d-flex justify-content-center">
          <Link
            to="#"
            onClick={loadMoreOrders}
            className={`cutsom-bttn ${!isVisibleShowMore ? "d-none" : ""}`}
          >
            {loading ? (
              <FontAwesomeIcon
                icon={faSpinner}
                spin
                size="lg"
                className="spinner-icon"
              />
            ) : (
              <>
                Show More Orders <img src={ShowMoreOrdersIcon} alt="" />
              </>
            )}
          </Link>
        </div>
      </div>

      {orderDetail && (
        <div
          className={`${
            isActive ? "order-details-info" : "order-details-info isHide"
          }`}
        >
         
          <div className="mobile-product-header d-flex d-md-none">
            <button type="button" className="mph-back"  onClick={() => handleToggle(orderDetail)}>
              <img src={BackArrow} alt="Back" />
            </button>
            <h1 className="mph-title">Order Details</h1>
          </div>
          <div className="tab-content-header d-none d-md-flex">
            <h3>
              <Link
                to=""
                className="backToList"
                onClick={() => handleToggle(orderDetail)}
              >
                <img src={BackImg} alt="" />
              </Link>{" "}
              Order Details
            </h3>
          </div>
          <div className="order-info-box">
            <div className="order-info-box-header">
              <h4>
                {orderDetail.order_number} <span></span> Qty :{" "}
                {sumOfqty(orderDetail.order_items)}
              </h4>
              <div className="order-info-box-header-right">
                <h5>
                  Order Date : <span>{formatDate(orderDetail.created_at)}</span>
                </h5>{" "}
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={`${process.env.REACT_APP_PHP_BACKEND_MEDIA_URL}${orderDetail.invoice_file}`}
                  download
                  className="cutsom-bttn track-order-bttn"
                >
                  <img src={InvoiceImg} alt="" /> Invoice
                </a>
              </div>
            </div>
            <div className="order-info-box-body">
              {orderDetail.order_items.map((item, item_index) => (
                <div className="order-info-box-item" key={"or-info-" + item.id}>
                  <div className="cart-box">
                    <div className="cart-box-img">
                      <Link to={"/products/" + item?.product.slug}>
                        <img
                         height={95}
                                    width={95}
                                    style={{ borderRadius: 10 }}
                          src={`${process.env.REACT_APP_PHP_BACKEND_MEDIA_URL}${item?.product.image}`}
                          alt=""
                        />
                      </Link>
                    </div>
                    <div className="cart-box-content">
                      <span>{item?.product?.category_title}</span>
                      <h2>
                        <Link to={"/products/" + item?.product.slug}>
                          {item?.product?.title}
                        </Link>
                      </h2>

                      <Link
                        to={"/products/" + item?.product.slug}
                        className="price-value"
                      >
                        {orderDetail.currency} {formatPrice(item.selling_price)}
                      </Link>
                      {item.status_id === 5 &&
                        new Date() <=
                          new Date(item.return_eligible_last_date) && (
                          <p className="return-text">
                            Return eligible through{" "}
                            {formatDate(item.return_eligible_last_date)}
                          </p>
                        )}
                    </div>
                  </div>
                  <div className="qty-wrapper d-none d-md-block">
                    <p className="mb-0"> Qty : {item.qty}</p>
                    <p className="mb-0">
                      {" "}
                      SubTotal : {orderDetail.currency}{" "}
                      {formatPrice(item.total_selling_price)}
                    </p>
                  </div>
                  <div className="bttn-group">
                    {displayTrackOrderDetails(item)}
                    {displayOrderStatus(item)}
                    {item.status_id === 5 &&
                      new Date() <=
                        new Date(item.return_eligible_last_date) && (
                        <Link
                          to=""
                          onClick={() => {
                            storeRefundItemInLocalStorage(item); // Pass item if needed
                            toggleReturnOrders();
                          }}
                          className="cutsom-bttn order-return-bttn"
                        >
                          <img src={OrderReturnIcon} alt="" /> Order Return
                        </Link>
                      )}
                  </div>
                </div>
              ))}
            </div>
            <div className="address-summary">
              <Row>
                <Col lg={6}>
                  <div className="summary-box">
                    <div className="box-header">
                      <h3 className="mb-0">Delivered on this Address</h3>
                    </div>
                    <div className="delivered-box">
                      <div className="delivered-box-img">
                        <img src={MapIcon} alt="" />
                      </div>
                      <div className="delivered-box-content">
                        <h4>{addressStringCreate(orderDetail?.address_obj)}</h4>
                      </div>
                    </div>
                    {orderDetail?.payment_obj !== null && (
                      <>
                        <div className="box-header">
                          <h3 className="mb-0">Payment Method</h3>
                        </div>
                        <div className="delivered-box method-group">
                          <div className="delivered-box-img">
                            <img
                              src={
                                orderDetail?.payment_obj?.card_type === "visa"
                                  ? Visa
                                  : orderDetail?.payment_obj?.card_type ===
                                      "mastercard"
                                    ? MasterCard
                                    : orderDetail?.payment_obj?.card_type ===
                                        "amex"
                                      ? AmericanExpress
                                      : orderDetail?.payment_obj?.card_type ===
                                          "discover"
                                        ? Discover
                                        : orderDetail?.payment_obj
                                              ?.card_type === "diners"
                                          ? AmericanExpress
                                          : orderDetail?.payment_obj
                                                ?.card_type === "jcb"
                                            ? AmericanExpress
                                            : null
                              }
                              alt="card"
                            />
                          </div>
                          <div className="delivered-box-content">
                            <p className="text-capitalize">
                              {orderDetail?.payment_obj?.card_type} Credit Card
                              ending in
                            </p>
                            <p className="card-number">
                              **** **** ****{" "}
                              {orderDetail?.payment_obj?.card_number}
                            </p>
                          </div>
                        </div>
                      </>
                    )}

                    <div className="box-header">
                      <h3 className="mb-0">Update Sent to</h3>
                    </div>
                    {orderDetail?.user_obj?.mobile_number && (
                      <div className="delivered-box mb-24">
                        <div className="delivered-box-img">
                          <img src={PhoneIcon} alt="" />
                        </div>
                        <div className="delivered-box-content">
                          <p>
                            <a
                              href={`tel:${formatPhoneNumber(
                                orderDetail.user_obj.mobile_number,
                              )}`}
                            >
                              {formatPhoneNumber(
                                orderDetail.user_obj.mobile_number,
                              )}
                            </a>
                          </p>
                        </div>
                      </div>
                    )}

                    {orderDetail?.user_obj?.email && (
                      <div className="delivered-box">
                        <div className="delivered-box-img">
                          <img src={MAilIcon} alt="" />
                        </div>
                        <div className="delivered-box-content">
                          <p>
                            <a href={`mailto:${orderDetail.user_obj.email}`}>
                              {orderDetail?.user_obj?.email}
                            </a>
                          </p>
                        </div>
                      </div>
                    )}

                    {/* <div className="box-header">
                      <h3 className="mb-0">Rate this Product</h3>
                    </div>
                    <div className="rate-product-box">
                      <div className="mb-30">
                        <Rating
                          onClick={handleRating}
                          initialValue={rating}
                          ratingValue={rating}
                          showTooltip={rating !== 0}
                          tooltipArray={["1", "2", "3", "4", "5"]}
                        />
                      </div>
                      <Form
                        noValidate
                        validated={validated}
                        onSubmit={handleSubmit}
                      >
                        <Form.Group
                          controlId="formDescription"
                          className="form-group"
                        >
                          <Form.Label>
                            Add Your Experience <span>*</span>
                          </Form.Label>
                          <Form.Control
                            as="textarea"
                            placeholder="Write here..."
                            rows={3}
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            Please add add your experience.
                          </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="form-group">
                          <div className="custom-file-input form-control">
                            <input
                              type="file"
                              id="file"
                              className="custom-file-input__input"
                            />
                            <label
                              htmlFor="file"
                              className="custom-file-input__label"
                            >
                              <p>Choose your file</p>
                              <span className="cutsom-bttn">Browse</span>
                            </label>
                          </div>
                        </Form.Group>
                        <Button type="submit" className="cutsom-bttn">
                          Submit
                        </Button>
                      </Form>
                    </div> */}
                  </div>
                </Col>
                <Col lg={6}>
                  {" "}
                  <CartSummary orderDetail={orderDetail} />
                </Col>
              </Row>
            </div>
          </div>
        </div>
      )}
      {/* Start Rating Modal */}
      <Modal
        show={RateProduct}
        onHide={RateProductClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Rate Product - {selectedRatingItem?.product?.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmitRating} noValidate>
            <Row>
              <Col md="12">
                <Form.Group className="mb-4">
                  <Form.Label>
                    Rating <span>*</span>
                  </Form.Label>
                  <Rating
                    onClick={handleRating}
                    initialValue={rating}
                    ratingValue={rating}
                    showTooltip={rating !== 0}
                    tooltipArray={["1", "2", "3", "4", "5"]}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.rating}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group>
                  <Form.Label>Comment</Form.Label>

                  <Form.Control
                    as="textarea"
                    placeholder="Write here..."
                    rows={3}
                    required
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.description}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md="12">
                <div className="bttn-group justify-content-center">
                  <Link
                    onClick={RateProductClose}
                    className="cutsom-bttn cancel-bttn"
                    type="button"
                  >
                    Cancel
                  </Link>
                  <Button
                    className="cutsom-bttn"
                    type="submit"
                    disabled={loading}
                  >
                    {loading ? (
                      <FontAwesomeIcon
                        icon={faSpinner}
                        spin
                        size="lg"
                        className="spinner-icon"
                      />
                    ) : (
                      "Rate Product"
                    )}
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
      {/* End Rating Modal */}
    </>
  );
}

export default MyOrdersComp;
